(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vl-policy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vl-policy')) {
    class VlPolicy extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-vlp-content]');
        this.toc = this.querySelector('[data-vlp-toc]');
        if (!this.content || !this.toc) return;

        this.list = this.toc.querySelector('[data-vlp-toc-list]');
        this.mq = window.matchMedia('(min-width: 990px)');
        this.controller = new AbortController();
        const signal = this.controller.signal;

        const selector = this.dataset.depth === 'h3' ? 'h2, h3' : 'h2';
        const headings = Array.from(this.content.querySelectorAll(selector)).filter(
          (heading) => heading.textContent.trim().length > 0
        );

        if (headings.length < 2) {
          this.toc.hidden = true;
          return;
        }

        this.buildList(headings);
        this.toc.hidden = false;
        this.syncOpen();

        this.mq.addEventListener('change', () => this.syncOpen(), { signal });

        this.list.addEventListener(
          'click',
          (event) => {
            const link = event.target.closest('a');
            if (!link) return;
            if (!this.mq.matches) this.toc.open = false;
            this.setActive(link.getAttribute('href').slice(1));
          },
          { signal }
        );

        this.observe(headings);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
      }

      slugify(text) {
        return text
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 60);
      }

      buildList(headings) {
        const used = new Set();
        this.links = new Map();
        this.list.replaceChildren();

        headings.forEach((heading, index) => {
          let base = heading.id || this.slugify(heading.textContent) || `section-${index + 1}`;
          let id = base;
          let n = 2;
          while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
            id = `${base}-${n}`;
            n += 1;
          }
          heading.id = id;
          used.add(id);

          const item = document.createElement('li');
          item.className = `vl-policy__toc-item vl-policy__toc-item--${heading.tagName.toLowerCase()}`;
          const link = document.createElement('a');
          link.className = 'vl-policy__toc-link';
          link.href = `#${id}`;
          const label = document.createElement('span');
          label.textContent = heading.textContent.trim();
          link.appendChild(label);
          item.appendChild(link);
          this.list.appendChild(item);
          this.links.set(id, link);
        });
      }

      syncOpen() {
        if (this.mq.matches) this.toc.open = true;
      }

      setActive(id) {
        if (!this.links) return;
        this.links.forEach((link, key) => {
          const on = key === id;
          link.classList.toggle('is-active', on);
          if (on) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }

      observe(headings) {
        if (typeof IntersectionObserver === 'undefined') return;
        const visible = new Set();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) visible.add(entry.target);
              else visible.delete(entry.target);
            });
            const current = headings.find((heading) => visible.has(heading));
            if (current) this.setActive(current.id);
          },
          { rootMargin: '0px 0px -65% 0px', threshold: 0 }
        );
        headings.forEach((heading) => this.observer.observe(heading));
      }
    }

    customElements.define('vl-policy', VlPolicy);
  }

  } catch(e) { console.error(e); }
})();
})();
